module.exports = __webpack_public_path__ + "img/bicycle-enclose.2bc141b5.jpg";